import { render, staticRenderFns } from "./ChapterNavigation.vue?vue&type=template&id=5f65fcce&scoped=true&"
import script from "./ChapterNavigation.vue?vue&type=script&lang=js&"
export * from "./ChapterNavigation.vue?vue&type=script&lang=js&"
import style0 from "./ChapterNavigation.vue?vue&type=style&index=0&id=5f65fcce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f65fcce",
  null
  
)

export default component.exports